module.exports = __webpack_public_path__ + "img/swiper3.d929b4f0.png";